
export default function Message() 
{
	return (
		<h1 className="text-xl dark:text-white">This is Message</h1>
		)
}
